<template>
    <div>
        <b-modal v-model="displayModal" :title="title">
            <div class="text-center" style="padding:0 40px;">
                <p style="text-align:left;margin-bottom:30px;">{{message}}</p>
            </div>
            <template v-slot:modal-footer>                
                <base-button type="primary" style="width:100%;" @click="navigateToUrl">{{navigateButtonText}}</base-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    export default {
        name: 'ModalWithLink',
        props: {
            Title: {
                type: String,
                default: '',
                description: 'Título del modal'
            },
            Message: {
                type: String,
                default: '',
                description: 'Mensaje del cuerpo del modal'
            },
            UrlToNavigate: {
                type: String,
                default: '',
                description: 'Url a la cual navegar'
            },
            NavigateButtonText: {
                type: String,
                default: 'Continuar',
                description: 'Texto del botón de navegación'
            }
        },
        data() {
            return {
                title: this.Title,
                message: this.Message,
                urlToNavigate: this.UrlToNavigate,
                navigateButtonText: this.NavigateButtonText,
                displayModal: false
            };
        },
        methods: {
            showModal () {
                this.displayModal = true;
            },
            showModalWithParams (title, message, urlToNavigate, navigateButtonText) {
                let context = this;

                context.title = title;
                context.message = message;
                context.urlToNavigate = urlToNavigate;
                context.navigateButtonText = navigateButtonText;
                
                context.showModal();
            },
            hideModal () {
                this.displayModal = false;
            },
            navigateToUrl () {
                this.hideModal();
                this.$router.push(this.urlToNavigate);
            }
        }
    }
</script>